import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import listMixin from '@/components/niotaClassic/listMixin';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import overviewEditMixin from '@/components/core/dtwin/overviewEditMixin';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
import { localizeDate } from '@/utils/vuex';
import ApiService from '@/services/apiService';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewDigitalTwinDigitalTwinList',
  mixins: [listMixin, listOptionsPersistenceMixin, overviewEditMixin, multiSearchMixin],
  data: function data() {
    return {
      twinObject: {},
      showExportDialog: false,
      list: [],
      isFetching: false,
      serverItemsLength: -1,
      listPersistencePath: 'DigitalTwin.list',
      searchMode: 'multi',
      favouriteMode: 'on',
      favouriteFilter: false,
      lastSearch: '',
      tableOptions: defaultTableOptions,
      defaultTableOptions: _objectSpread({}, defaultTableOptions),
      disableFetchOnCreatedMixin: true
    };
  },
  computed: {
    localizedTableOptions: function localizedTableOptions() {
      return {
        headers: [{
          text: this.$i18n_t('Common.id'),
          value: 'id',
          align: 'right',
          sortable: true
        }, {
          text: this.$i18n_t('Common.help.titel'),
          value: 'title',
          sortable: true
        }, {
          text: this.$i18n_t('Common.hierarchyLevel'),
          value: 'hierarchyLevel',
          sortable: true
        }, {
          text: this.$i18n_t('Common.tenant'),
          sortable: true,
          value: 'tenant.name'
        }, {
          text: "".concat(this.$i18n_t('DigitalTwin.DigitalTwin.list.states'), " / ").concat(this.$i18n_t('DigitalTwin.DigitalTwin.list.rules')),
          sortable: false,
          value: 'statesCount'
        }, // {
        //   text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
        //   sortable: true,
        //   value: 'floorDtwin.title',
        // },
        {}],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    twinDuplicatePrompt: function twinDuplicatePrompt() {
      if (this.twinDuplicatePrompt) {
        this.loadStates(this.twinObject);
      } else {
        this.twinDataStates = null;
      }
    },
    twinSyncPrompt: function twinSyncPrompt() {
      if (this.twinSyncPrompt) {
        this.loadStates(this.twinObject);
      } else {
        this.twinDataStates = null;
      }
    }
  },
  mounted: function mounted() {
    this.getMultiFilterData();
  },
  methods: {
    localizeDate: localizeDate,
    handleRowClick: function handleRowClick(item) {
      this.$router.push("/digitaltwin-mgmt/".concat(item.id));
    },
    breadCrumbsPath: function breadCrumbsPath() {
      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }, this.$i18n_t('DigitalTwin.DigitalTwin.listView')];
    },
    deleteTwin: function deleteTwin(selected) {
      var _this = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.$store.state.app.dtwins = {};
      ApiService.digitalTwinDelete(selected.id).then(function () {
        _this.twinDeletePrompt = false;

        _this.$snack(_this.$i18n_t('Common.digitalTwins.twinDeleted'), 'success');

        _this.$store.state.app.dtwins = {};

        _this.fetchList();
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack(_this.$i18n_t('Common.digitalTwins.twinDeletedFail'), 'error');
        }
      }).finally(function () {
        _this.$store.state.app.loading = false;
      });
    },
    detailTableHeaderColClass: function detailTableHeaderColClass(header, props) {
      var classes = ["text-".concat(header.align || 'start')];

      if (header.sortable && ['title', 'id', 'floorDtwin.title'].indexOf(header.value) < 0) {
        classes.push('sortable');
      }

      var values = [header.value];

      if (props.options.sortBy && props.options.sortBy.length && values.indexOf(props.options.sortBy[0]) >= 0) {
        classes.push('active');

        if (props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0]) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }

      return classes.join(' ');
    },
    detailTableHeaderClasses: function detailTableHeaderClasses(props) {
      var sortBy = props.options.sortBy && props.options.sortBy.length ? props.options.sortBy[0] : 'none';
      var sortDesc = props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0];
      return {
        text: {
          title: "header-item-sortable ".concat(sortBy === 'title' ? 'header-active' : 'header-nonactive'),
          id: "header-item-sortable ".concat(sortBy === 'id' ? 'header-active' : 'header-nonactive') // floorDtwinTitle: `header-item-sortable ${
          //   sortBy === 'floorDtwin.title' ? 'header-active' : 'header-nonactive'
          // }`,

        },
        icon: {
          title: sortBy === 'title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          id: sortBy === 'id' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive' // floorDtwinTitle: sortBy === 'floorDtwin.title' ? (sortDesc ? 'icon-desc' : '') : 'icon-nonactive',

        }
      };
    },
    fetchList: function fetchList() {
      var _this2 = this;

      var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });

      if (!isEqual(this.lastSearch, JSON.stringify(searchItems))) {
        this.lastSearch = JSON.stringify(searchItems);
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var tableOptions = fromStart ? _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      }) : this.tableOptions;
      var sortBy = tableOptions.sortBy,
          sortDesc = tableOptions.sortDesc,
          page = tableOptions.page,
          itemsPerPage = tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : false;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = page ? page - 1 : 0;
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var filters = [];
      var accountIds = this.selectedAccounts.map(function (a) {
        return a.id;
      });

      if (accountIds.length) {
        filters.push({
          type: 'tenantIds',
          ids: accountIds
        });
      } // persist options for next call of this page (during this browser-tab-session)


      this.$store.state.app.pageFilters = _objectSpread(_objectSpread({}, this.$store.state.app.pageFilters), {}, {
        DigitalTwin: _objectSpread(_objectSpread({}, get(this.$store.state.app, 'pageFilters.DigitalTwin') || {}), {}, {
          list: {
            searchDetails: this.searchItems,
            tableOptions: tableOptions,
            favouriteFilter: this.favouriteFilter || false
          }
        })
      });
      ApiService.digitalTwinsFetch(this, null, null, filters, this.favouriteFilter ? ['favourites'] : null, {
        variable: sortItem,
        direction: sortDirection
      }, usedPage * usedItemsPerPage, usedItemsPerPage, searchItems).then(function (res) {
        _this2.list = res.digitaltwins;
        _this2.serverItemsLength = res.totalCount;
      }).catch(function (error) {
        console.error('Error fetching twin-list', error);
      }).finally(function () {
        _this2.isFetching = false;
      });
    },
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
};